module.exports = __webpack_public_path__ + "img/Emerald.3d3db436.jpg";